import React, { useState, useEffect } from 'react'

const QueueManagement: React.FC = () => {
  const [iframeKey, setIframeKey] = useState(0)
  const [iframeError, setIframeError] = useState(false)
  const [sessionReady, setSessionReady] = useState(false)
  const [sessionError, setSessionError] = useState<string | null>(null)

  // 建立 Bull Board session
  useEffect(() => {
    const createSession = async () => {
      try {
        const token = localStorage.getItem('auth_token')
        if (!token) {
          setSessionError('需要登入才能訪問佇列管理')
          return
        }

        const response = await fetch('/api/admin/bull-board-session', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        })

        if (response.ok) {
          setSessionReady(true)
        } else {
          const error = await response.json()
          setSessionError(error.error || '無法建立 Bull Board session')
        }
      } catch (error) {
        console.error('Failed to create Bull Board session:', error)
        setSessionError('網路錯誤，無法建立連線')
      }
    }

    createSession()
  }, [])

  const handleRefresh = () => {
    setIframeKey(prev => prev + 1)
    setIframeError(false)
    setSessionReady(false)
    setSessionError(null)

    // 重新建立 session
    const createSession = async () => {
      try {
        const token = localStorage.getItem('auth_token')
        if (!token) {
          setSessionError('需要登入才能訪問佇列管理')
          return
        }

        const response = await fetch('/api/admin/bull-board-session', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        })

        if (response.ok) {
          setSessionReady(true)
        } else {
          const error = await response.json()
          setSessionError(error.error || '無法建立 Bull Board session')
        }
      } catch (error) {
        setSessionError('網路錯誤，無法建立連線')
      }
    }

    createSession()
  }

  const handleOpenInNewTab = () => {
    // 使用獨立的 /queue 路徑
    window.open('/queue', '_blank')
  }

  const handleIframeError = () => {
    setIframeError(true)
  }

  return (
    <div className="h-screen flex flex-col">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 flex-shrink-0">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-semibold text-gray-900">佇列管理</h1>
            <p className="text-sm text-gray-600 mt-1">監控和管理 RAG 索引處理佇列</p>
          </div>
          <div className="flex space-x-2">
            <button
              onClick={handleRefresh}
              className="bg-gray-100 text-gray-700 px-3 py-2 rounded-md hover:bg-gray-200 text-sm"
            >
              🔄 重新整理
            </button>
            <button
              onClick={handleOpenInNewTab}
              className="bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 text-sm"
            >
              🗗 新分頁開啟
            </button>
          </div>
        </div>
      </div>

      {/* Bull Board iframe、載入中或錯誤訊息 */}
      <div className="flex-1 overflow-hidden">
        {sessionError ? (
          <div className="h-full flex items-center justify-center bg-gray-50">
            <div className="text-center max-w-md mx-auto p-6">
              <div className="text-red-500 text-4xl mb-4">⚠️</div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">無法訪問佇列管理</h2>
              <p className="text-gray-600 mb-4">{sessionError}</p>
              <div className="space-y-2">
                <button
                  onClick={handleOpenInNewTab}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 block w-full"
                >
                  在新分頁中開啟佇列管理
                </button>
                <button
                  onClick={handleRefresh}
                  className="text-blue-600 hover:underline text-sm"
                >
                  重新載入
                </button>
              </div>
            </div>
          </div>
        ) : !sessionReady ? (
          <div className="h-full flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600">正在建立佇列管理連線...</p>
              <p className="text-sm text-gray-400 mt-2">設定認證 session 中</p>
            </div>
          </div>
        ) : iframeError ? (
          <div className="h-full flex items-center justify-center bg-gray-50">
            <div className="text-center max-w-md mx-auto p-6">
              <div className="text-red-500 text-4xl mb-4">⚠️</div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">無法載入佇列管理介面</h2>
              <p className="text-gray-600 mb-4">
                介面載入失敗，請嘗試重新整理或在新分頁中開啟
              </p>
              <div className="space-y-2">
                <button
                  onClick={handleOpenInNewTab}
                  className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 block w-full"
                >
                  在新分頁中開啟佇列管理
                </button>
                <button
                  onClick={handleRefresh}
                  className="text-blue-600 hover:underline text-sm"
                >
                  重新載入
                </button>
              </div>
            </div>
          </div>
        ) : (
          <iframe
            key={iframeKey}
            src="/queue"
            className="w-full h-full border-0"
            title="Queue Management"
            onError={handleIframeError}
          />
        )}
      </div>
    </div>
  )
}

export default QueueManagement